import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid, GridRowSelectionModel } from "@mui/x-data-grid";
import { Form, Formik, FormikErrors } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";

import ConfirmationDialog from "../../components/dialog/simple-alert";
import DialogQuestionnaire from "../../components/dialogquestionnaire/dialog-questionnaire";
import DropdownlistComponentValidation from "../../components/dropdownlistvalidation/dropdownlist-validation-mui";
import Loading from "../../components/loading/loading";
import TextFieldDateValidationComponent from "../../components/textfielddatevalidation/textfield-date-validation-mui";
import { useProfileColumns } from "../../hooks/use-profile-columns/context";
import { IFormLoR } from "../../interfaces/IFormLoR";
import { homeStyle } from "../../styles/container/home";
import useViewModel from "./ViewModel";

function ListOfRequestRevamped() {
  const {
    data: { requestStatus, requestType, filter, loadingActive, listTrRequest },
    method: {
      onGetRequestStatus,
      onGetRequestType,
      onDeleteSelected,
      onSubmitForm,
      onGetListOfRequest,
      handleExport,
    },
  } = useViewModel();

  const { columns: columnsToUse } = useProfileColumns();
  const [isDialogOpenConfirmation, setIsDialogOpenConfirmation] =
    useState(false);
  const [showTableRequest, setShowTableRequest] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>([]);

  useEffect(() => {
    onGetRequestStatus();
    onGetRequestType();
  }, []);

  useEffect(() => {
    if (filter.startDateValue !== "" && filter.endDateValue !== "") {
      onGetListOfRequest();
    }
  }, [filter]);

  const initialValues: IFormLoR = {
    startDate: moment().format("YYYY-MM-DD").toString(),
    endDate: moment().format("YYYY-MM-DD").toString(),
    requestType: "All",
    status: "All",
  };

  const validation = (values: IFormLoR) => {
    const errors: FormikErrors<IFormLoR | undefined> = {};

    if (values.startDate === "") {
      errors.startDate = "Start Date must be filled";
    }

    if (
      values.startDate !== null &&
      values.endDate != null &&
      values.startDate > values.endDate
    ) {
      errors.endDate = "End Date must not be earlier than Start Date";
    }

    return errors;
  };

  const handleSearchOnClick = () => {
    if (filter.startDateValue !== "" && filter.endDateValue !== "") {
      onGetListOfRequest(searchText);
    }
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px" }} className="black">
        List of Request
        <hr />
      </Box>
      <br />

      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={(values, _) => {
            onSubmitForm(values);
            setShowTableRequest(true);
          }}
          validate={validation}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={6} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Tanggal Awal / <i>Start Date </i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateValidationComponent
                    propsData={props}
                    name="startDate"
                    onChildDataChange={() => setShowTableRequest(false)}
                  />
                  {props.errors.startDate && (
                    <div className="error-message">
                      {props.errors.startDate}
                    </div>
                  )}
                </Grid>

                <Grid item lg={6} md={6} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Tanggal Akhir / <i>End Date </i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateValidationComponent
                    propsData={props}
                    name="endDate"
                    onChildDataChange={() => setShowTableRequest(false)}
                  />
                  {props.errors.endDate && (
                    <div className="error-message">{props.errors.endDate}</div>
                  )}
                </Grid>

                <Grid item lg={6} md={6} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jenis Permohonan / <i>Request Type </i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    name="requestType"
                    ddlData={requestType}
                    onChildDataChange={() => setShowTableRequest(false)}
                  />
                </Grid>

                <Grid item lg={6} md={6} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Status Permohonan / <i> Request Status </i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    name="status"
                    ddlData={requestStatus}
                    onChildDataChange={() => setShowTableRequest(false)}
                  />
                </Grid>
              </Grid>

              <br />
              <div
                style={{ display: "flex", justifyContent: "center", gap: "3%" }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{
                    textTransform: "none",
                    width: "150px",
                  }}
                >
                  View
                </Button>

                {showTableRequest && (
                  <Button
                    variant="outlined"
                    color="primary"
                    sx={{
                      background: "white",
                      width: "150px",
                      textTransform: "none",
                    }}
                    onClick={() => handleExport()}
                  >
                    Export
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          marginBottom: "10px",
        }}
      >
        {showTableRequest && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              marginBottom: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                marginTop: "20px",
              }}
            >
              <div className="searchDataTable">
                <TextField
                  placeholder="Search"
                  variant="outlined"
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearchOnClick();
                    }
                  }}
                />
                <Button
                  onClick={handleSearchOnClick}
                  style={{ padding: 0, minWidth: "40px" }}
                >
                  <SearchOutlinedIcon className="black" />
                </Button>
              </div>
            </Box>
          </Box>
        )}
      </Box>

      {selectedRows.length > 0 && (
        <Button
          variant="contained"
          sx={homeStyle.buttonDeleteStyle}
          onClick={() => setIsDialogOpenConfirmation(true)}
        >
          <span> </span>
          <DeleteOutlinedIcon />
        </Button>
      )}

      {showTableRequest && (
        <div style={{ width: "100%", backgroundColor: "white" }}>
          <DataGrid
            rows={listTrRequest || []}
            columns={columnsToUse}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            getRowId={(row) => row.requestID}
            pageSizeOptions={[5, 10, 20, 50]}
            checkboxSelection
            onRowSelectionModelChange={(row) => setSelectedRows(row)}
            isRowSelectable={(params) => params.row.requestNumber === "-"}
            autoHeight
            getRowHeight={() => "auto"}
          />
        </div>
      )}

      <ConfirmationDialog
        open={isDialogOpenConfirmation}
        title="Confirmation Title"
        message="Are you sure you want to proceed?"
        onConfirm={() => {
          onDeleteSelected(selectedRows);
          setIsDialogOpenConfirmation(false);
        }}
        onCancel={() => {
          setIsDialogOpenConfirmation(false);
        }}
      />

      <DialogQuestionnaire open={false} />

      <Loading open={loadingActive} />
    </Container>
  );
}

export default ListOfRequestRevamped;
